import { formatDate } from '../../lib/formatters';
import { Gwei } from '../../lib/gwei';
import { multiply } from '../../lib/math';
import { Badge } from '../catalyst-ui-kit/badge';
import { FundingRateBreakdown } from '../FundingRateBreakdown/FundingRateBreakdown';

interface TooltipPayload {
  value: number;
  payload: {
    isProjected: boolean;
  };
}
interface CustomTooltipProps {
  active?: boolean;
  payload?: TooltipPayload[];
  label?: string | number;
}

export const FundingChartTooltip: React.FC<CustomTooltipProps> = ({ active, payload, label }) => {
  const firstPayload = payload?.[0];
  if (active && firstPayload && label !== undefined) {
    const fundingRateProjected1h = Gwei.toGwei(firstPayload.value);
    const fundingRateProjected8h = multiply(fundingRateProjected1h, Gwei.toGwei(8));
    const fundingRateProjected1d = multiply(fundingRateProjected1h, Gwei.toGwei(24));
    const fundingRateProjected1y = multiply(fundingRateProjected1d, Gwei.toGwei(365));

    return (
      <div className="w-[200px] rounded bg-backgroundPrimary p-2 text-contentSecondary">
        <p className="mb-2 flex justify-between text-xs">
          <span className="text-contentPrimary">
            {typeof label === 'number'
              ? formatDate(new Date(label), { timeStyle: 'short' })
              : label}
          </span>
          {firstPayload.payload.isProjected && <Badge>Projected</Badge>}
        </p>

        <div className="text-3xs">
          <FundingRateBreakdown
            className="flex-col gap-2"
            valueClassName="flex justify-between text-3xs"
            fundingRateProjected1h={fundingRateProjected1h}
            fundingRateProjected8h={fundingRateProjected8h}
            fundingRateProjected1d={fundingRateProjected1d}
            fundingRateProjected1y={fundingRateProjected1y}
          />
        </div>
      </div>
    );
  }
  return null;
};
